import { useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import CancelMutation from 'mutations/inspection/cancel';
import Form from 'components/inspection/modal/cancel/cancel_form';

const Cancel = ({ inspection, handleClose, onSuccess }) => {
  const setError = useError();
  const [cancelInspection, { loading }] = useMutation(CancelMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.inspection.cancel');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.inspection.cancel" />
      </ModalTypography>
      <Form
        initialValues={{
          notes: inspection.notes || undefined,
          canceledAt: new Date(),
          id: inspection.id,
        }}
        processing={loading}
        onSubmit={(values) => cancelInspection({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Cancel;
